import { PurchasesCommitmentsTab } from "@/components/blocks/purchases/purchases-commitments-tab";

import { useProjectDetailsContext } from "../context";

export function PurchasesTab() {
  const ctx = useProjectDetailsContext();
  const {
    project,
    employees,
    numericProjectId,
    budgetData,
  } = ctx;

  // Total cost budget — used by the Committed Cost KPI card progress bar.
  // Falls back to 0 (hides the bar) when no cost budget has been set.
  const costBudgetTotal = budgetData?.costBudget?.totals?.budget ?? 0;

  return (
    <>
      <PurchasesCommitmentsTab
        projectId={numericProjectId}
        projectCode={project?.code}
        employees={employees}
        costBudgetTotal={costBudgetTotal}
      />
    </>
  );
}
